<template>
  <div class="graph-components">
    <div class="graph-wrapper">
      <table class="graph-active" :width="`${graphNumber}%`">
      </table>
      <div class="graph-number Longfont">
        {{graphNumber}}<span>%</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FukidashiTitle',
  props: {
    graphNumber: String,
  },
  data() {
		return {
      intersectionObserver: null,
		}
	},
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "250px",
        // threshold: [0,0.2,0.4,0.6,0.8,1.0],
        threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.graph-wrapper'));
    this.startIntersectionObserver(targets);
  },
  destroyed () {
    this.intersectionObserver.disconnect(); // すべての target に対し，監視をやめる
  }
}
</script>
<style scoped lang="scss">
.graph-wrapper {
  margin-top: 50px;
  width: 100%;
  height: 130px;
  background-color: #b6b6b6;
  position: relative;
  border-radius: 5px;
  &:not(.is-show) {
    .graph-active {
      width: 0;
    }
  }
}
.graph-active {
  background-color: #ffce48;
  position: absolute;
  height: 100%;
  top: 0;
  border-radius: 5px 0px 0px 5px;
  transition: width 3s cubic-bezier(1, 0, 0, 1);
}
.graph-number {
  position: relative;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  font-size: 99px;
  color: #e51c57;
  span {
    font-size: 50px;
  }
}
</style>
